
import Logo from '../assets/image/acrfi.png';
import Sign from '../assets/image/signs.png';

export default function GratitudeLetter({ data, year }) {
    const today = new Date();
    const formatted = today.toLocaleDateString('en-US');
    return (
        <div id="gratitude-preview"
            style={{ maxHeight: '10.5in', overflow: 'hidden' }}
            className="relative max-w-3xl mx-auto p-8 bg-white text-black text-xs font-serif leading-relaxed flex flex-col min-h-[10in]"
        >
            <img
                src={Logo}
                alt="Background"
                className="absolute inset-1 m-auto w-[450px] h-auto opacity-20 pointer-events-none"
                style={{ zIndex: 1 }}
            />

            <div className="mb-4">

                <img src={Logo} alt="Sp1" className='max-h-full cursor-pointer -mt-8' />
                <div className="flex justify-end">
                    <p>Date: {formatted}</p>
                </div>
                <div className="flex justify-start mt-1">
                    <p>Ref. No.: {year}/{data?.id}/ACRFI/DONATE</p>
                </div>
            </div>

            <div className="text-right mb-4">
                <p className='uppercase'>To: {data?.name}</p>
                <p>{data?.adress.split(' ').slice(0, -3).join(' ')}</p>
                <p>{data?.adress.split(' ').slice(-3).join(' ')}</p>
                <p>Email: <span className='text-blue-500 underline'>{data?.email}</span></p>
            </div>

            <div className="text-right mb-1">
                <p className='underline'><strong>Issued in Miami</strong></p>
            </div>
            <div>
                <span className="mt-2 flex flex-col   "> <p >Re: <span className='underline'> Acknowledgement and gratitude </span></p><p className='underline'>for your generous donations in {year}</p></span>
            </div>


            <div className="mb-2 mt-4">
                <p>Dear Mr/Mrs. {data?.surname},</p>
                <p className="mt-4">
                    On behalf of Amero Congo Relief Foundation Inc., we extend our sincerest
                    gratitude for your remarkable generosity and support. Your contribution has
                    made a profound impact on our ability to fulfill our mission of providing
                    care to at-risk children. Please accept this letter as an acknowledgement.
                </p>
            </div>

            <div className="mb-1">
                <p><strong>Donation:</strong> $ {data?.amount}</p>
            </div>

            <div className="mb-1">
                <p>
                    Your selfless act of giving ensures the continuity of our program and
                    initiatives. We deeply value our trust and commitment to our cause.
                </p>
                <p className="mt-4">
                    <strong className="underline">This notice shall serve you as your yearly documentation for tax purposes.</strong> If
                    you have further inquiries, please feel free to contact us.
                </p>
                <p className="mt-2">Once again, thank you for your great support and kindness.</p>
            </div>

            <div className="mb-6 border-b border-blue-500 pb-4">
                <p>Warm regards!</p>
                <img src={Sign} alt="sign" className='h-14 cursor-pointer' />
                <p className=" font-bold">Dylan KABUANSEYA</p>
                <p>For the Financial Office</p>
                <p className='mb-1'>Amero-Congo Relief Foundation Inc.</p>
            </div>

            <div className=" pt-8 text-[10px] text-gray-600 -mt-6 mb-0">
                <p className="font-bold">AMERO-CONGO RELIEF FOUNDATION INC</p>
                <p>A 501(c)(3) Public Charity</p>
                <p>1167 NW 49th Street</p>
                <p>Miami FL 33127</p>
                <p>Email: <span className="text-blue-500 underline">acrfi@sofkam.com</span></p>
                <p>Phone: +1 305 607 2284</p>
            </div>
        </div>
    );
}
